import script from "./BaseSkeleton.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseSkeleton.vue?vue&type=script&lang=ts&setup=true"

import "./BaseSkeleton.vue?vue&type=style&index=0&id=5cd64ca8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cd64ca8"]])

export default __exports__